import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _class, _class2;

import { OidcTokenStorage } from './storage/OidcTokenStorage';
import { OidcAccessToken } from './tokens/OidcAccessToken';
import { OidcIdToken } from './tokens/OidcIdToken';
import { singleton } from './utils/singleton';
export let AuthorizationCodeTokenClient = singleton(_class = (_class2 = class AuthorizationCodeTokenClient {
  constructor(options) {
    _defineProperty(this, "options", void 0);

    _defineProperty(this, "storage", void 0);

    this.options = options;
    this.storage = this.options.storage ?? new OidcTokenStorage();
  }

  async initializeTokenFromAuthorizationCode() {
    const authCode = this.storage.authorizationCode.get();

    if (!authCode) {
      throw new Error(`Auth - missing authorization code`);
    }

    const tokenData = await this.requestToken(authCode);
    const accessToken = new OidcAccessToken(tokenData.access_token);
    this.storage.setAccessToken(accessToken);
    const idToken = new OidcIdToken(tokenData.id_token);
    this.storage.setIdToken(idToken);
    this.storage.authorizationCode.remove();
    return true;
  }

  async requestToken(authCode) {
    try {
      const redirectUri = this.storage.redirectUri.get();

      if (!redirectUri) {
        throw new Error(`Redirect URI is missing`);
      }

      const codeVerifier = this.storage.codeVerifier.get();

      if (!codeVerifier) {
        throw new Error(`Code verifier is missing`);
      }

      const tokenRequest = fetch(`${this.options.identityUrl}/connect/token`, { ...AuthorizationCodeTokenClient.REQUEST_OPTIONS,
        body: new URLSearchParams({
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          client_id: this.options.clientId,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          grant_type: 'authorization_code',
          code: authCode,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          redirect_uri: redirectUri,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          code_verifier: codeVerifier
        })
      });
      const response = await tokenRequest;

      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      const result = response.json();
      return result;
    } catch (error) {
      throw new Error(`Token request has failed: ${error}`);
    }
  }

}, _defineProperty(_class2, "REQUEST_OPTIONS", {
  credentials: 'same-origin',
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Fetch-Api': '1',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Requested-With': 'XMLHttpRequest',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  method: 'POST'
}), _class2)) || _class;
//# sourceMappingURL=AuthorizationCodeTokenClient.js.map